import { Component, OnInit, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'cleaner-doc',
    templateUrl: '../../templates/partials/doc-cleaner.html'
})

export class DocCleanerComponent implements OnInit {
    @Output() showModal = new EventEmitter();
    constructor() { }

    openModal(type){
        //console.log("openModal");
        this.showModal.emit(type);
    }

    ngOnInit() { }
}


// WEBPACK FOOTER //
// ./src/app/modules/cleaners/components/dummy/doc-cleaner.component.ts